import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { Loading, AccessDenied } from "@/components/States";

import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import Community from "@/pages/Community";
import HowItWorks from "@/pages/HowItWorks";
import LegalPage from "@/pages/LegalPage";
import PublicProfile from "@/pages/PublicProfile";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import VerifyEmail from "@/pages/auth/VerifyEmail";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import Dashboard from "@/pages/app/Dashboard";
import MyCards from "@/pages/app/MyCards";
import Wishlist from "@/pages/app/Wishlist";
import Matches from "@/pages/app/Matches";
import MatchDetail from "@/pages/app/MatchDetail";
import Proposals from "@/pages/app/Proposals";
import ProposalDetail from "@/pages/app/ProposalDetail";
import SettingsPage from "@/pages/app/SettingsPage";
import Onboarding from "@/pages/app/Onboarding";
import Admin from "@/pages/admin/Admin";

function Protected({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Layout><Loading /></Layout>;
  if (!user) return <Navigate to={`/accedi?next=${encodeURIComponent(loc.pathname)}`} replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Layout><Loading /></Layout>;
  if (!user) return <Navigate to="/accedi?next=/admin" replace />;
  if (user.role !== "admin") return <Layout><AccessDenied message="Questa area è riservata agli amministratori." /></Layout>;
  return children;
}

const L = (el) => <Layout>{el}</Layout>;

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={L(<Home />)} />
        <Route path="/scambi" element={L(<Explore />)} />
        <Route path="/community" element={L(<Community />)} />
        <Route path="/come-funziona" element={L(<HowItWorks />)} />
        <Route path="/collezionista/:username" element={L(<PublicProfile />)} />
        <Route path="/regolamento" element={L(<LegalPage slug="regolamento" />)} />
        <Route path="/sicurezza" element={L(<LegalPage slug="sicurezza" />)} />
        <Route path="/assistenza" element={L(<LegalPage slug="assistenza" />)} />
        <Route path="/termini" element={L(<LegalPage slug="termini" />)} />
        <Route path="/privacy" element={L(<LegalPage slug="privacy" />)} />
        <Route path="/cookie" element={L(<LegalPage slug="cookie" />)} />

        <Route path="/accedi" element={<Login />} />
        <Route path="/registrati" element={<Register />} />
        <Route path="/verifica-email" element={<VerifyEmail />} />
        <Route path="/recupera-password" element={<ForgotPassword />} />
        <Route path="/reimposta-password" element={<ResetPassword />} />

        <Route path="/onboarding" element={<Protected>{L(<Onboarding />)}</Protected>} />
        <Route path="/dashboard" element={<Protected>{L(<Dashboard />)}</Protected>} />
        <Route path="/le-mie-carte" element={<Protected>{L(<MyCards />)}</Protected>} />
        <Route path="/wishlist" element={<Protected>{L(<Wishlist />)}</Protected>} />
        <Route path="/match" element={<Protected>{L(<Matches />)}</Protected>} />
        <Route path="/match/:userId" element={<Protected>{L(<MatchDetail />)}</Protected>} />
        <Route path="/proposte" element={<Protected>{L(<Proposals />)}</Protected>} />
        <Route path="/proposte/:id" element={<Protected>{L(<ProposalDetail />)}</Protected>} />
        <Route path="/impostazioni" element={<Protected>{L(<SettingsPage />)}</Protected>} />
        <Route path="/admin" element={<AdminOnly>{L(<Admin />)}</AdminOnly>} />

        <Route path="*" element={L(<NotFound />)} />
      </Routes>
    </BrowserRouter>
  );
}
